/** 11 digits as `XX-XXXXXXXX-X`; anything else is returned unchanged. */
export function formatTaxId(taxId: string): string {
  const digits = taxId.replace(/\D/g, '');

  if (digits.length !== 11) {
    return taxId;
  }

  return `${digits.slice(0, 2)}-${digits.slice(2, 10)}-${digits.slice(10)}`;
}
